<template>
<!-- 他们有个活动页先简单复制粘贴使用 -->
  <ul class="show-list clearfix">
    <li class="fl" v-for="(item, index) in list" :key="index" @click="toDetail(item.id)">
      <div class="img-box">
        <img class="backimg" :src="util.getPicUrl(item.cover, 'imgsmall')" alt="">
        <span class="visit-num">{{item.viewNum}}</span>
        <!-- <i class="vr-url" v-if="item.vrUrl"></i> -->
        <div class="cover" v-if="false">
          <p>扫码查看</p>
          <div class="qr-box">
            <canvas></canvas>
          </div>
          <span class="view-btn">点击查看</span>
        </div>
      </div>
      <h3 class="omitline1">{{item.title}}</h3>
      <p class="omitline1">{{item.museumName}}</p>
      <div class="thumbNum-box" :class="{zan: item.isZan}" @click.stop="addZan(index)">
       <div>{{item.thumbNum || 0}}</div>
        <i></i>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'ShowList',
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  computed: {
  },
  methods: {
    addZan (index) {
      this.$emit('addZan', index)
    },
    toDetail (id) {
      this.$router.push('/detail/' + id)
    }
  }
}
</script>

<style lang="scss">
  .show-list{
    margin-left: 0;
    width: 1200px;
    height: 858px;
    margin-right: -20px;
    opacity: 1;
    transform: translateY(0);
    &.fadeUp-enter {
      transform: translateY(50px);
      opacity: 0;
    }
    &.fadeUp-enter-active {
      transition: all 1s;
    }
    li{
      width: 220px;
      margin-right: 20px;
      font-size: 16px;
      line-height: 16px;
      text-align: center;
      margin-bottom: 50px;
      cursor: pointer;
      position: relative;
      box-shadow: 0 2px 4px 0 #EEEEEE;
      &:hover{
        .backimg{
          transform: scale3d(1.1, 1.1, 1);
          transition: transform 0.6s !important;
        }
      }
      .img-box{
        width: 206px;
        margin: auto;
        height: 300px;
        border-radius: 3px;
        font-size: 0;
        overflow: hidden;
        position: relative;
        .backimg{
          width: 206px;
          height: 300px;
          transition: transform 0.3s;
        }
        .visit-num{
          display: inline-block;
          padding: 6px 6px 6px 31px;
          background: rgba(0,0,0,0.30);
          border-radius: 13px;
          font-size: 13px;
          color: #FFFFFF;
          letter-spacing: 0;
          line-height: 13px;
          position: absolute;
          left: 10px;
          top: 10px;
          &::before{
            content: ' ';
            width: 16px;
            height: 13px;
            background: url("../assets/images/visit-icon.png") no-repeat 0 0;
            background-size: 100% 100%;
            position: absolute;
            left: 10px;
            top: 6px;
          }
        }
        .vr-url{
          width: 70px;
          height: 70px;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate3d(-50%, -50%, 0);
          background: url("../assets/images/360.png") no-repeat 0 0;
          background-size: 100% 100%;
        }
      }
      .cover{
        width: 206px;
        margin: auto;
        display: none;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,0.55);
        opacity: 0;
        p{
          width: 100%;
          font-size: 14px;
          color: #FFFFFF;
          letter-spacing: 0;
          line-height: 20px;
          text-align: center;
          margin-top: 51px;
          height: 20px;
          opacity: 0;
        }
        .qr-box{
          margin: 20px auto 0;
          width: 118px;
          height: 118px;
          background: rgba(255,255,255,0.5);
          position: relative;
          opacity: 0;
        }
        img{
          width: 100px;
          height: 100px;
          position: absolute;
          left: 9px;
          top: 9px;
        }
        .view-btn{
          display: block;
          width: 88px;
          top: 30px;
          background: #AD0C09;
          border-radius: 14px;
          margin: 20px auto 0;
          font-size: 14px;
          color: #FFFFFF;
          letter-spacing: 0;
          line-height: 30px;
          cursor: pointer;
        }
      }
      h3{
        width: 206px;
        margin: auto;
        margin-top: 15px;
        color: #35343D;
        text-align: left;
      }
      p{
        width: 130px;
        margin: auto;
        margin-top: 8px;
        margin-bottom: 9px;
        line-height: 20px;
        height: 18px;
        color: #8193AE;
        text-align: left;
        font-size: 12px;
        margin-left: 8px;
      }
      .thumbNum-box {
        position: absolute;
        bottom: 9px;
        right: 6px;
        display: flex;
        height: 30px;
        align-items: flex-end;
        div {
          font-size: 12px;
          color: #B8B8B8;
          letter-spacing: 0;
          // transform: scale(0.66);
          line-height: 12px;
          height: 12px;
        }
        i {
          display: block;
          width: 16px;
          height: 16px;
          background: url("../assets/images/dianzan1.png") no-repeat 0 0;
          background-size: 100% 100%;
          margin-left: 5px;
        }
        &.zan {
          .div {
            color: #FD5D5DB8;
          }
          i {
            background: url("../assets/images/dianzan.png") no-repeat 0 0;
            background-size: 100% 100%;
          }
        }
      }
    }
  }
</style>
